export default{
	//baseURL:'http://192.168.1.21:7072/',   //hardy.liu
	// baseURL:'http://hardy.free.idcfengye.com/api',   //hardy.liu
	 baseURL: 'http://m.fyzxjyzx.com/api',      //正式
	method:'POST',
	headers: {'Content-Type':'application/x-www-form-urlencoded'},
	transformRequest: [
	    function(data) {
	      	let ret = ''
	      	for (let it in data) {
	        	ret += encodeURIComponent(it) +
	          	'=' +
	          	encodeURIComponent(data[it]) +
	          	'&'
	      	}
	      	return ret
	    }
	],
	timeout: 20000
}



// WEBPACK FOOTER //
// ./src/api/base.js